import React from "react";

import { useHistory } from "react-router-dom";

import TableHeader from "../../../../components/Table/TableHeader";
import TablePagination from "../../../../components/Table/TablePagination";
import FormControl from "@material-ui/core/FormControl";
import InputSearch from "../../../../components/InputSearch";

const tabelaColunas = [
  "# Deal",
  "Data / Hora",
  "Nome da Oportunidade",
  "Vendedor",
  "Motivo oferta",
  "Status Deal",
  "Ações",
];

const PerfilSellerListOportunidade = ({
  response,
  buscar,
  busca,
  mudarPagina,
}) => {
  const history = useHistory();

  const changePage = (page) => {
    mudarPagina(page);
  };

  const gotoDet = (idOportunidade) => {
    history.push(`/seller/oportunidade/editar/${idOportunidade}`);
  };

  const formatarData = (value) => {
    const data = new Date(value);

    return `${data.toLocaleDateString()} ${data.toLocaleTimeString(
      navigator.language,
      {
        hour: "2-digit",
        minute: "2-digit",
      }
    )}`;
  };

  return (
    <div>
      <div className="row justify-content-end">
        <div className="col-md-3 mt-3">
          <FormControl>
            <InputSearch buscar={buscar} buscaPor={busca} />
          </FormControl>
        </div>
      </div>
      <div className="row">
        <div className="col-12 mt20">
          <div className="table-responsive">
            <table className="table">
              <TableHeader columns={tabelaColunas} />

              <tbody>
                {(!response?.lista || response?.lista.length === 0) && (
                  <tr>
                    <td colSpan="7"> Sem Registros </td>
                  </tr>
                )}
                {response?.lista &&
                  response?.lista?.map((data) => (
                    <tr key={data.id}>
                      <td> {data.codigo.toString().padStart(6, "0")} </td>
                      <td> {formatarData(data.dataHora)} </td>
                      <td> {data?.nomeOportunidade} </td>
                      <td> {data?.vendedor} </td>
                      <td>
                        {(data?.detalheLote &&
                          data?.detalheLote[0]?.motivoOferta) ||
                          data.motivoOferta}
                      </td>
                      <td> {data.status} </td>
                      <td className="text-right">
                        <i
                          className="btn-edit-icon btn btn-icon fa fa-edit"
                          onClick={() => gotoDet(data.id)}
                        ></i>
                      </td>
                      <td>Ações</td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <TablePagination data={response} changePage={changePage} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerfilSellerListOportunidade;
